export const backgroundCheckRoutes = {
  path: "background-checks",
  name: "background-check index",
  meta: {
    label: "Background Checks",
  },
  component: () => import("@/pages/background-check/BackgroundCheckIndex.vue")
}
